import { useEffect, useState } from "react";
import { RowDensity } from "../enum/RowDensity";
import { useAppSelector } from "./useAppSelector";

// Map class names for each density
const rowDensityClassMap: Record<RowDensity, string> = {
  [RowDensity.EXTRA_SMALL]: "size_x_small",
  [RowDensity.SMALL]: "size_small",
  [RowDensity.NORMAL]: "size_normal",
};

// Map heights (in px) for each density
const rowDensityHeightMap: Record<RowDensity, number> = {
  [RowDensity.EXTRA_SMALL]: 24,
  [RowDensity.SMALL]: 30,
  [RowDensity.NORMAL]: 36,
};

export function useRowDensity() {
  const rowDensity = useAppSelector(
    (state) => state.configSlice.selectedRowDensity
  );

  const [rowDensityClass, setRowDensityClass] = useState("size_normal");
  const [rowDensityHeight, setRowDensityHeight] = useState(RowDensity.NORMAL);

  useEffect(() => {
    const density = rowDensity ?? RowDensity.NORMAL;

    setRowDensityClass(rowDensityClassMap[density]);
    setRowDensityHeight(rowDensityHeightMap[density]);
  }, [rowDensity]);

  return { rowDensityClass, rowDensityHeight };
}
